const LANGUAGE_CHANGED = (state, lang) => {
  state.lang = lang
}

const LOADING_PAGE_START = (state) => {
  state.loadingPage = true
}

const LOADING_PAGE_END = (state) => {
  state.loadingPage = false
}

const DESKTOP_DEVICE_SET = (state) => {
  state.device = 'desktop'
}

const MOBILE_DEVICE_SET = (state) => {
  state.device = 'mobile'
}

const SAVING_FORM = (state, onGoing) => {
  state.savingForm = onGoing
}

const CMS_BLOCK_LOADING = (state) => {
  state.cmsLoading = true
  state.cmsError = false
}

const CMS_BLOCK_UPDATED = (state, cmsBlock) => {
  state.cmsLoading = false
  state.cmsId = cmsBlock.code
  state.cms[cmsBlock.code] = {
    code: cmsBlock.code,
    html: cmsBlock.html,
    title: cmsBlock.title
  }
}

const CMS_BLOCK_ERROR = (state) => {
  state.homepageBlocksLoading = false
  state.homepageBlocksError = true
}

const HOMEPAGE_BLOCKS_LOADING = (state) => {
  state.homepageBlocksLoading = true
  state.homepageBlocksError = false
}

const HOMEPAGE_BLOCKS_UPDATED = (state, sliders) => {
  state.homepageBlocksLoading = false
  state.homepageBlocks = sliders
}

const HOMEPAGE_BLOCKS_ERROR = (state) => {
  state.homepageBlocksLoading = false
  state.homepageBlocksError = true
}

const PERIOD_LOADING = (state) => {
  state.periodLoading = true
  state.periodError = false
}

const PERIOD_UPDATED = (state, data) => {
  state.periodLoading = false
  state.period = data
}

const PERIOD_ERROR = (state) => {
  state.periodLoading = false
  state.periodError = true
}

const SET_PAGE_TOOLBAR_TITLE = (state, title) => {
  state.pageToolbarTitle = title
}

const SET_PAGE_TOOLBAR_SUBTITLE = (state, subtitle) => {
  state.pageToolbarSubtitle = subtitle
}

const SET_PAGE_TOOLBAR_DROPDOWN_LIST = (state, list) => {
  state.pageToolbarDropdownList = list
}

const SET_PREV_PERIOD = (state, data) => {
  state.prevPeriod = data
}

const SET_PAGE_TOOLBAR_DROPDOWN_SELECTED_ITEM = (state, item) => {
  state.pageToolbarDropdownSelectedItem = item
}

const APP_TOGGLE_FEATURES = (state, toggleFeatures) => {
  state.toggleFeatures = toggleFeatures
}

const SET_PAGE_DIALOG = (state, dialog) => {
  state.pageDialog = dialog
}

const SET_TOOLBAR_BUTTON = (state, value) => {
  state.pageToolbarButton = value
}

const SET_HIDE_PAYMENT = (state, value) => {
  state.hidePayment = value
}

const PAGE_CONFIGURATION = (state, configs) => {
  state.pageToolbar = configs.toolbar
  state.pageToolbarTitle = configs.toolbarTitle
  state.pageToolbarSubtitle = null
  state.pageToolbarDropdown = configs.toolbarDropdown
  state.pageToolbarSelect = configs.pageToolbarSelect
  state.pageToolbarButton = configs.toolbarButton
  state.pageToolbarButtonLabel = configs.toolbarButtonLabel
  state.pageToolbarInfoIcon = configs.toolbarInfoIcon
  state.toolbarDropdownConfig = configs.toolbarDropdownConfig
  state.pageToolbarNotificationIcon = configs.pageToolbarNotificationIcon
  state.pageDialog = configs.dialog
  state.pageNavigationDrawer = configs.navigationDrawer
  state.pageBottomNavigation = configs.bottomNavigation
  state.pageMobileLayoutType = configs.mobileLayoutType
  state.pageMobileSelectedMenu = configs.mobileSelectedMenu
  state.pageDesktopLayoutType = configs.desktopLayoutType
  state.pageDesktopSelectedMenu = configs.desktopSelectedMenu
}

export default {
  APP_TOGGLE_FEATURES,

  LANGUAGE_CHANGED,

  DESKTOP_DEVICE_SET,
  MOBILE_DEVICE_SET,
  SAVING_FORM,

  CMS_BLOCK_LOADING,
  CMS_BLOCK_UPDATED,
  CMS_BLOCK_ERROR,

  HOMEPAGE_BLOCKS_LOADING,
  HOMEPAGE_BLOCKS_ERROR,
  HOMEPAGE_BLOCKS_UPDATED,

  PERIOD_LOADING,
  PERIOD_ERROR,
  PERIOD_UPDATED,

  LOADING_PAGE_START,
  LOADING_PAGE_END,

  PAGE_CONFIGURATION,
  SET_PAGE_DIALOG,
  SET_PAGE_TOOLBAR_TITLE,
  SET_PAGE_TOOLBAR_SUBTITLE,
  SET_PAGE_TOOLBAR_DROPDOWN_LIST,
  SET_PAGE_TOOLBAR_DROPDOWN_SELECTED_ITEM,
  SET_PREV_PERIOD,
  SET_TOOLBAR_BUTTON,
  SET_HIDE_PAYMENT
}
